import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { isNil } from 'lodash';

export const useDerivedState = <T>(
  initialState: T,
  customDependency?: any[],
): [derivedState: T, setDerivedState: Dispatch<SetStateAction<T>>] => {
  const [derivedState, setDerivedState] = useState(initialState);

  const dependency: any[] = !isNil(customDependency)
    ? customDependency
    : [initialState];

  useEffect(
    function initDerivedState() {
      setDerivedState(initialState);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependency,
  );

  return [derivedState, setDerivedState];
};
